/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Program_NameInputs */

const en_subtitle_export_program_name = /** @type {(inputs: Subtitle_Export_Program_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Program Name`)
};

const fr_subtitle_export_program_name = /** @type {(inputs: Subtitle_Export_Program_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du programme`)
};

const de_subtitle_export_program_name = /** @type {(inputs: Subtitle_Export_Program_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programmname`)
};

const it_subtitle_export_program_name = /** @type {(inputs: Subtitle_Export_Program_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome del programma`)
};

const ru_subtitle_export_program_name = /** @type {(inputs: Subtitle_Export_Program_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название программы`)
};

const es_subtitle_export_program_name = /** @type {(inputs: Subtitle_Export_Program_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre del programa`)
};

const zh_cn2_subtitle_export_program_name = /** @type {(inputs: Subtitle_Export_Program_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`程序名称`)
};

const ja_subtitle_export_program_name = /** @type {(inputs: Subtitle_Export_Program_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プログラム名`)
};

const hi_subtitle_export_program_name = /** @type {(inputs: Subtitle_Export_Program_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कार्यक्रम का नाम`)
};

const pt_pt2_subtitle_export_program_name = /** @type {(inputs: Subtitle_Export_Program_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do programa`)
};

/**
* | output |
* | --- |
* | "Program Name" |
*
* @param {Subtitle_Export_Program_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_program_name = /** @type {((inputs?: Subtitle_Export_Program_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Program_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_program_name(inputs)
	if (locale === "de") return de_subtitle_export_program_name(inputs)
	if (locale === "it") return it_subtitle_export_program_name(inputs)
	if (locale === "ru") return ru_subtitle_export_program_name(inputs)
	if (locale === "es") return es_subtitle_export_program_name(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_program_name(inputs)
	if (locale === "ja") return ja_subtitle_export_program_name(inputs)
	if (locale === "hi") return hi_subtitle_export_program_name(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_program_name(inputs)
	return en_subtitle_export_program_name(inputs)
});